window.addEventListener('scroll', function() {
  var scrollPosition = window.scrollY || document.documentElement.scrollTop;

  var body = document.body;

  if (scrollPosition > 100) {
    body.classList.add('scrolled');
  } else {
    body.classList.remove('scrolled');
  }
});

$(function(){
  $(document).on('change', '#checkbox-amazonpay', function() {
      if ($(this).is(':checked')) {
        if($.trim($('#CartSpecialInstructions').val()) === ''){
         $('.cart__checkout').addClass('is-disabled');
         $('.description-amazonpay-button').show();
        }
        $('.description-amazonpay').show();
      } else {
         if($('#checkbox-terms').is(':checked')){
           $('.cart__checkout').removeClass('is-disabled');
         }
         $('.description-amazonpay').hide();
         $('.description-amazonpay-button').hide();
      }
  });

  $(document).on('change', '#CartSpecialInstructions', function() {
      if ($('#checkbox-amazonpay').is(':checked') && $.trim($('#CartSpecialInstructions').val()) === '') {
         $('.cart__checkout').addClass('is-disabled');
         $('.description-amazonpay-button').show();
      } else {
         if($('#checkbox-terms').is(':checked')){
           $('.cart__checkout').removeClass('is-disabled');
         }
         $('.description-amazonpay-button').hide();
      }
  });

  $(document).on('change', '#checkbox-terms', function() {
      if ($(this).is(':checked')) {
         if(!$('#checkbox-amazonpay').is(':checked') || $('#checkbox-amazonpay').is(':checked') && $.trim($('#CartSpecialInstructions').val()) !== ''){
           $('.cart__checkout').removeClass('is-disabled');
         }
         $('.description-terms-button').hide();
      } else {
         $('.cart__checkout').addClass('is-disabled');
         $('.description-terms-button').show();
      }
  });

  $(document).on('submit', '.ajaxcart', function() {
      if ($('#checkbox-amazonpay').is(':checked') && $.trim($('#CartSpecialInstructions').val()) === '') {
         $('.description-amazonpay-button').show();
          return false;
      }
      if (!$('#checkbox-terms').is(':checked')) {
         $('.description-terms-button').show();
          return false;
      }
  });
  
})